const imageSliders = document.querySelectorAll('[data-slider="image-slider"]');

const imageSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 6,
  speed: 800,
  allowTouchMove: true,
  loop: true,
  breakpoints: {
    1200: {
      spaceBetween: 20,
      allowTouchMove: false,
    },
    1440: {
      spaceBetween: 20,
      allowTouchMove: false,
    },
  },
};

imageSliders.forEach((el) => {
  const sliderEle = new Swiper(el, imageSliderOptions);
  swiperLockClass(el, sliderEle);

  const clickableArea = el.querySelector('.swiper-wrapper');

  clickableArea.addEventListener('click', () => {
    sliderEle.slideNext(500);
  });
});
